/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCDownIcon20Regular = forwardRef('ArrowCDownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16.78 6.845a.75.75 0 0 1 0 1.06l-4.836 4.836a2.75 2.75 0 0 1-3.889 0L3.22 7.905a.75.75 0 0 1 1.06-1.06l4.837 4.836a1.25 1.25 0 0 0 1.768 0l4.835-4.836a.75.75 0 0 1 1.061 0Z" })));
});
